// Copyright (c) StrangeBee 2024

import { ICONS } from '@Constants/iconsApp';
import { useLocalMessage } from '@Helpers/';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement } from 'react';
import IconLabel from '@Atoms/Info/IconLabel/IconLabel';

import './OwnerIcon.scss';
interface OwnerIconProps {
    isOwner: boolean;
    showText?: boolean;
}

const OwnerIcon = ({ isOwner, showText = false }: OwnerIconProps): ReactElement => {
    const i = useLocalMessage();

    const icon = isOwner ? (
        <ICONS.OrganisationIcon className="owner-icon__icon" />
    ) : (
        <ICONS.ShareAltOutlined className="owner-icon__icon" />
    );

    const tradLabel = isOwner ? 'case.list.table.isOwner' : 'case.list.table.shared';

    if (showText) {
        return <IconLabel icon={icon} label={i(tradLabel)} className="text-normal" />;
    }

    return <THTooltip title={i(tradLabel)}>{icon}</THTooltip>;
};

export default OwnerIcon;
